import { Box, Stack } from "@mui/material";
import React from "react";

import { FontStyle, JobDisplays } from "../../constants";
import { jobButtonStyle, JobFontSize } from "../../utils/jobUtils";

const styles = {
  container: {
    width: "100%",
    height: "100%",
    maxHeight: "calc(100vh - 24px)",
    position: "absolute",
    top: 0,
    left: 0,
    pointerEvents: "none",
    // padding: JobDisplays.padding,
    // px: "0px",
    // ...FontStyle.body,
    // minWidth: "",
    zIndex: 1000,
    opacity: 0,
    // transformOrigin: "top left",
    transform: "translateY(-20px) scaleX(1.1)",
    transition: "all 0.4s ease",

    ...FontStyle.body,
    textAlign: "center",
    fontSize: "24px",
  },
  containerVisible: {
    transform: "translateX(0%) scale(1)",
    opacity: 1,
  },
  bgBox: {
    position: "absolute",
    borderRadius: JobDisplays.borderRadius,
    boxShadow: JobDisplays.boxShadow,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0.5,
    zIndex: -1,
    // zIndex: 2000,
  },
};

export const OverlayNames = {
  matches: "matches",
  jobDetails: "jobDetails",
  content: "content",
  resourceShort: "resourceShort",
  resource: "resource",
};

const descriptionData = {
  [OverlayNames.matches]: {
    // title: "Meet Your\nMatches",
    title: "Matches",
    upperText: true,
    disableLogo: true,
    bg: {
      // backgroundColor: "#4158D0",
      // backgroundImage:
      //   "linear-gradient(45deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)",
      backgroundImage:
        "radial-gradient( circle 130vh at 11.8% 45.5%,  #BDBAE8 0%, #D9B1DE 100.2% )",
    },
  },
  [OverlayNames.jobDetails]: {
    title: "Job Details",
    upperText2: true,
    disableLogo: true,
    text: {
      // fontSize: "32px",
    },
    bg: {
      // fontSize: "32px",
      backgroundImage:
        "radial-gradient( circle 80vmax at 31.8% 65.5%,  #7EE7F2 0%, rgba(166,239,253,1) 90.1% )",
      // "radial-gradient( circle 80vmax at 31.8% 65.5%,  rgba(97,186,255,1) 0%, rgba(166,239,253,1) 90.1% )",
    },
  },
  [OverlayNames.content]: {
    title: "Tutorials",
    bg: {
      backgroundImage:
        "radial-gradient( circle 440px at 31.8% 65.5%,  #FFFC00 0%, rgb(250, 250, 150) 100.7% )",
      // backgroundImage:
      //   "radial-gradient( circle 860px at 11.8% 33.5%,  rgba(136,238,189,1) 0%, rgba(243,237,162,1) 100.7% )",
    },
  },
  [OverlayNames.resourceShort]: {
    title: "Resource",
    slim: true,
    bg: {
      backgroundImage:
        // "radial-gradient( circle 440px at 11.8% 33.5%, rgba(14,174,87,1) 0%, #20EF99 90% )",
        "linear-gradient(to right, rgba(250, 250, 150), #6dd5ed)",
    },
  },
  [OverlayNames.resource]: {
    title: "Resource",
    bg: {
      backgroundImage:
        // "radial-gradient( circle 80vmax at 31.8% 65.5%, rgba(14,174,87,1) 0%, #20EF99 90% )",
        "linear-gradient(to right, rgba(250, 250, 150), #6dd5ed)",
    },
  },
};

const DescriptionOverlay = ({ visible, name }) => {
  // visible is a string and either is all or contains name
  const shouldDisplay = visible === "all" || visible.includes(name);
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        ...styles.container,
        ...descriptionData[name].text,
        ...(shouldDisplay && {
          ...styles.containerVisible,
        }),
      }}>
      <Box
        sx={{
          ...styles.bgBox,
          ...descriptionData[name].bg,
        }}
      />
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          ...descriptionData[name].bg,
          fontWeight: "bold",
          py: descriptionData[name].slim ? 2 : 4,
          px: 4,
          borderRadius: JobDisplays.borderRadius,
        }}>
        {!descriptionData[name].disableLogo && (
          <Box
            sx={{
              ...FontStyle.logo,
              fontSize: "24px",
            }}>
            Fetti
          </Box>
        )}
        {descriptionData[name].upperText && <Box>Meet Your</Box>}
        {descriptionData[name].upperText2 && <Box>View Your</Box>}
        <Box>{descriptionData[name].title}</Box>
      </Stack>
    </Stack>
  );
};

export default DescriptionOverlay;
